import {CrudModel} from '@ngx-ivengi/crud';

export class Floor extends CrudModel {
  public name: string;
  public number: number;

  public setName(name: string): Floor {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setNumber(number: string): Floor {
    if(typeof number === 'number') {
      this.number = number;
    } else if(typeof number === 'string' && !isNaN(parseInt(number, 10))) {
      this.number = parseInt(number, 10);
    }
    return this;
  }

  public fromResponse(response: any): void {
    this
      .setId(response.id)
      .setName(response.name)
      .setNumber(response.number);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/floor/floor.model.ts